<template>
  <section class="h-full d-flex flex-column">
    <div class="mdc-top-app-bar__row">
       <TopAppBarDrawer
        :isDrawerOpen="isDrawerOpen"
        @closeDrawer="closeDrawer"
      ></TopAppBarDrawer>
    <div class="sm_header">
       
        <button class="menu_btn" @click="openDrawer()">
          <span>mobile menu</span>
        </button>
         <h1 >{{ $t("1289") }}</h1>
    </div>
     
    </div>

    <div id="tab1" class="t-color-gray2 pdl-16 pdr-16 pdt-16 pdb-32">
      <div
        class="bg-white header-card mdc-card mdc-elevation--z3 mgb-16 pda-default"
        @click="info"
      >
        <div 
          class="overflow-visible d-flex align-items-center"
        >
          <div
            class="w-40 h-40 overflow-visible t-headline7 iconHolder min-w-40 t-color-white font-r d-flex justify-content-center align-items-center position-relative background-size-cover"
            style="border-radius: 50%; overflow: hidden"
            :style="`background: url(${personalInfo && profileImage && profileImage.length > 0 ? personalInfo.profile : 'images/ic_account.png'}) center`"
          >
            <ProfileTier :data="personalInfo" :className="'size-18'" />
          </div>

          
          <div class="w-full pdl-16 d-flex justify-content-between">
            <div
              class="w-full d-flex justify-content-between align-items-center"
            >
              <div>
                <div class="t-body1 t-color-title l-spacing48 font-r d-inline-block t-line-h-1em">
                  {{
                    personalInfo && personalInfo.name
                      ? personalInfo.name.fullName
                      : ""
                  }}
                  <ProfileTierName :data="personalInfo" :className="'d-inline-block position-relative bottom-2'" />
                </div>
                <div>
                  <span class="t-helper t-color-content1">{{
                    personalInfo ? personalInfo.userId : ""
                  }}</span>
                </div>
              </div>
              <div>
                <i class="material-icons">keyboard_arrow_right</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-white header-card mdc-card mdc-elevation--z3">
        <!-- <div class="d-flex align-items-center listItems pda-default border-bottom">
          <div class="h-24">
            <i class="w-24 h-24 material-icons">notifications_none</i>
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >{{ $t('1290') }}</div>
          <div class="cursor-pointer mgt-8" @click="notiStatus = !notiStatus">
            <div class="mdc-switch mdc-switch--checked">
              <span
                class="material-icons toggle-size"
                :class="{'active-checked': notiStatus}"
              >{{ notiStatus ? 'toggle_on' : 'toggle_off' }}</span>
            </div>
          </div>
        </div> -->

        <!-- <div class="to-dc d-flex align-items-center listItems pda-default border-bottom" >
          <div class="w-24 h-24">
            <img src="images/seal.svg" alt class="w-24 h-24" />
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >{{ $t('1291') }}</div>
          <div class="mgt-8">
            <div
              class="cursor-pointer mdc-switch mdc-switch--checked"
              @click="badgeStatus = !badgeStatus"
            >
              <span
                class="material-icons toggle-size"
                :class="{'active-checked': badgeStatus}"
              >{{ badgeStatus ? 'toggle_on' : 'toggle_off' }}</span>
            </div>
          </div>
        </div> -->

        <!-- <hr class="mdc-list-divider" />
          <router-link class="mdc-list-item" to="/member/changepassword">
            <span
              class="drawer-icon-size material-icons mdc-list-item__graphic"
            >
              <img src="images/icons/lock-off.svg" alt />
            </span>
            {{ $t("2049") }}
          </router-link> -->

        <div
          class="d-flex align-items-center listItems pda-default border-bottom"
          @click="changePassword"
        >
          <div class="w-24 h-24 material-icons">
            <!-- <i class="w-24 h-24 material-icons">security</i> -->
            <img src="images/icons/lock-off.svg" alt />
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >
            {{ $t("2049") }}
          </div>
          <div class="mgt-8">
            <i class="w-24 h-24 material-icons">keyboard_arrow_right</i>
          </div>
        </div>

        <div
          class="d-flex align-items-center listItems pda-default border-bottom"
          @click="privacy"
        >
          <div class="h-24">
            <i class="w-24 h-24 material-icons">security</i>
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >
            {{ $t("1292") }}
          </div>
          <div class="mgt-8">
            <i class="w-24 h-24 material-icons">keyboard_arrow_right</i>
          </div>
        </div>

        <div
          class="d-flex align-items-center listItems pda-default border-bottom"
          @click="terms"
        >
          <i class="w-24 h-24 material-icons-outlined">task</i>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >
            {{ $t("1293") }}
          </div>
          <div class="mgt-8">
            <i class="w-24 h-24 material-icons">keyboard_arrow_right</i>
          </div>
        </div>

        <div
          class="d-flex align-items-center listItems pda-default border-bottom"
          @click="lang"
        >
          <div class="h-24">
            <i class="w-24 h-24 material-icons">public</i>
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >
            {{ $t("1294") }}
          </div>
          <div class="mgt-8">
            <i class="w-24 h-24 material-icons">keyboard_arrow_right</i>
          </div>
        </div>

        <div
          class="d-flex align-items-center listItems pda-default border-bottom"
          @click="helpdesk"
        >
          <div class="w-24 h-24">
            <!-- <img src="images/help.svg" alt class="w-24 h-24 mgx-auto" /> -->
            <i class="w-24 h-24 material-icons">help</i>
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >
            {{ $t("2059") }}
          </div>
          <div class="mgt-8">
            <i class="w-24 h-24 material-icons">keyboard_arrow_right</i>
          </div>
        </div>

        <!-- <div
          class="d-flex align-items-center listItems pda-default border-bottom" @click="access"
        >
          <div class="h-24">
            <i class="w-24 h-24 material-icons">accessibility</i>
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >{{ $t('1295') }}</div>
          <div class="mgt-8">
            <i class="w-24 h-24 material-icons">keyboard_arrow_right</i>
          </div>
        </div> -->

        <!-- <div
          class="d-flex align-items-center listItems pda-default border-bottom"
          @click="appversion"
        >
          <div class="h-24">
            <i class="w-24 h-24 material-icons">cloud_queue</i>
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >{{ $t('1296') }}</div>
          <div class="mgt-8">
            <i class="w-24 h-24 material-icons">keyboard_arrow_right</i>
          </div>
        </div> -->

        <div
          class="d-flex align-items-center listItems pda-default border-bottom"
          @click.prevent="deleteCache"
        >
          <div class="h-24">
            <i class="w-24 h-24 material-icons">build</i>
          </div>
          <div
            class="t-body1 t-color-title l-spacing48 font-r pdl-16 pdr-16 mgr-auto"
          >
            {{ $t("1297") }}
          </div>
          <div class="mgt-8 d-flex align-items-center">
            <div class="t-body3 t-color-red3 pdr-8"></div>
            <i class="w-24 h-24 material-icons">keyboard_arrow_right</i>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Components/Mixin/Extend/API define
import httpService from "@/api/httpService.js";
import memberApi from "@/api/memberApi.js";
// Components/Mixin/Extend/API define
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

import { topAppBarMixin } from "@/mixins/topAppBar.js";
import ProfileTier from "@/components/common/ProfileTier.vue";
import ProfileTierName from '@/components/common/ProfileTierName.vue';

import { clearLocalStorageExcept } from "@/utils/logoutUtil";

export default {
  components: {
    TopAppBar,
    TopAppBarDrawer,
    ProfileTier,
    ProfileTierName
},
  mixins: [topAppBarMixin],
  data() {
    return {
      CACHE_SIZE: 64,
      notiStatus: false,
      badgeStatus: true,
      personalInfo: null,
      profileImage: null,
      isDrawerOpen: false,

    };
  },
  mounted() {
    // this.setTopAppBarBackSearch(this.$t("1289"));
    this.fatchData();
  },
  methods: {
    fatchData() {
      memberApi.getMemberInfo().then((response) => {
        this.personalInfo = response.data.data;
        this.profileImage = this.personalInfo ? this.personalInfo.profile : "";
      });
    },
    changePassword() {
      this.$router.push("/member/changepassword");
    },
    privacy() {
    this.$router.push("privacy");
    },
    terms() {
      this.$router.push("/terms");
    },
    lang() {
      this.$router.push("/language");
    },
    access() {
      this.$router.push("access-right");
    },
    appversion() {
      this.$router.push("app-version");
    },
    info() {
      this.$router.push("/member/myinfo");
    },
    helpdesk() {
      this.$router.push("/helpdesk");
    },

    deleteCache() {
      clearLocalStorageExcept()
      this.total = "";
      this.$snackOpen({
        contents: this.$t("1940"),
        btnDisplayYN: false,
      });
      this.$router.push("/brandselect");
    },
    // Open drawer
    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
};
</script>


<style scoped>
.sm_header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e9e9e9;
  z-index: 4;
  background-color: #fff;
  box-shadow: none;
}
.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 1.25rem;
  font-weight: 500;
  height: 55px;
  line-height: 55px;
  margin-top: 0px;
}
.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}
.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}
.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}
.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}
.sm_header .search_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url(/images/search_btn.svg) center center no-repeat;
  background-size: 22px auto;
}

.shadow {
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.toggle-size {
  font-size: 2.5rem;
}

.link-color {
  color: #2d6dcc;
}

.border-bottom {
  border-bottom: 1px solid #e6eced;
}

.active-checked {
  color: #212121;
}
.cursor-pointer {
  cursor: pointer;
}
.iconHolder {
  background: #ff847b;
  border-radius: 50%;
}
</style>
